// SubTaskItem Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IconButton from '../../common/icon_button/icon_button.jsx'

class SubTaskItem extends Component {
  static get propTypes () {
    return {
      subtask: PropTypes.object
    }
  }

  static get defaultProps () {
    return {
      subtask: null
    }
  }

  render () {
    const { subtask } = this.props

    return (
      <div className='subtask-item'>
        <div className='image'>
          <IconButton icon='tasks' size='big' type='transparent' canHover />
        </div>
        <div className='info'>
          <div className='title'>{subtask.title}</div>
          <div
            className='description'
            dangerouslySetInnerHTML={{ __html: subtask.description }}
          />
        </div>
      </div>
    )
  }
}

export default SubTaskItem
